import {
    serverBus
} from '@/main'
import SessionManager from '@/Manager/Session.manager';
import KeyboardManager from '@/Manager/keyboard.manager'
import TextareaManager from '@/Manager/Textarea.manager'
import Global from '@/scripts/Global'
import FolderApi from '@/scripts/api/folder.api'
import VueSignals from '@/scripts/VueSignals';

export default {
    name: 'MentionFolder',
    data() {
        return {
            showAvailableContent: false,
            generated_list_spinner: false,
            folder_content: [],
            all_folders: [],
            is_empty: false,
            subfolder: false,
            folder_tree: [SessionManager.getActiveChannel().channel_id],
            folder_name: SessionManager.getActiveChannel().channel_name,
            mention_filter_mode: false,
            mention_match: '',
            endOfContent: false,
            skip: 20,
            windowWidth: window.innerWidth,
            filterMode: false,
            mention_id: '',
            spanMention: null
        }
    },
    mounted() {
        serverBus.$on(VueSignals.CREATE_MENTION_FOLDER, (success) => {
            this.ListContent(SessionManager.getActiveChannel().channel_id, 0)
            this.mention_id = Global.SaltID(5)
            Global.globalValue(VueSignals.FOLDER_LIST_CONTENT, true)
        })

        serverBus.$on("mention_delete_open_list_folder", (params) => {
            this.spanMentionId = params.id;
            Global.globalValue(VueSignals.FOLDER_LIST_CONTENT, true);
            this.triggerMentionSearch(params.search);
        })

        serverBus.$on(VueSignals.HIDE_KEYBOARD_GENERATED_LIST, (success) => {
            this.showAvailableContent = false
        })

        serverBus.$on(VueSignals.KEYBOARD_CLOSE_MESSAGE_LIST, (success) => {
            if (this.showAvailableContent) {
                Global.globalValue(VueSignals.HIDE_KEYBOARD_FOLDER_LIST, true)
            }
        })

        serverBus.$on("windowResize", (success) => {
            this.windowWidth = window.innerWidth
        })

        serverBus.$on(VueSignals.FOLDER_LIST_CONTENT, (success) => {
            // if (this.windowWidth > 680) {
                KeyboardManager.setListOpen(true)
                KeyboardManager.setMentionInstruc()
                this.showAvailableContent = true
                this.mention_filter_mode = true
                this.filterMode = true
            // }
        })

        serverBus.$on(VueSignals.HIDE_KEYBOARD_FOLDER_LIST, (success) => {
            this.showAvailableContent = false
            this.mention_filter_mode = false
            this.filterMode = false
            this.mention_match = ''
            // setTimeout(function(){KeyboardManager.setListOpen(false)}, 100)
        })


        serverBus.$on(VueSignals.KEYBOARD_FILTERED_FF, (ff) => {
            if (ff.length == 0) {
                Global.globalValue(VueSignals.HIDE_KEYBOARD_FOLDER_LIST, true)
            } else {
                Global.globalValue(VueSignals.FOLDER_LIST_CONTENT, true)
            }
            this.folder_content = ff
        })

        //@TODO Refactor
        serverBus.$on(VueSignals.MENTION_MENTION_TAG_FF_FEED, (e) => {
            if (this.mention_filter_mode && this.showAvailableContent && this.folder_content.length > 0) {
                if (this.filterMode) {
                    if (e.key === "Backspace") { // refill and show if it has a value
                        this.mention_match = this.mention_match.slice(0, this.mention_match.length - 1)
                    } else {
                        if (!KeyboardManager.getSpecialKeys().includes(e.key) && e.key.length == 1) {
                            this.mention_match += e.key
                        }
                    }
                    this.triggerMentionSearch();
                    if (e.code == "Enter" || e.code == "Space" && document.querySelector('.mention-item.active') != null) {
                        e.preventDefault()
                        let active_mention_item = document.querySelector('.mention-item.active').innerText.trim()
                        let mention_type = document.querySelector('.mention-item.active').dataset.type
                        let mention_id = document.querySelector('.mention-item.active').id
                        Global.globalValue(VueSignals.KEYBOARD_NAVIGATE_MENTION_ITEM, {
                            "mention_item": active_mention_item,
                            "mention_id": mention_id,
                            "mention_type": mention_type
                        })
                        Global.globalValue(VueSignals.KEYBOARD_CHOOSE_MENTION_ITEM, document.querySelector('.mention-item.active').id)
                        Global.globalValue(VueSignals.HIDE_KEYBOARD_FOLDER_LIST, true)
                    }
                }
            }
        })



        serverBus.$on(VueSignals.MENTION_FILE, (data) => {
            this.mention_id = Global.SaltID(5)
            this.addMention(data.ff_id)
            this.NaveMention(data.ff_name, data.ff_id, data.ff_type)
        })

        serverBus.$on(VueSignals.KEYBOARD_NAVIGATE_MENTION_ITEM, (data) => {
            if (data.mention_type == 'file' || data.mention_type == 'folder') {
                this.NaveMention(data.mention_item, data.mention_id, data.mention_type)
            }
        })

        serverBus.$on(VueSignals.KEYBOARD_CHOOSE_MENTION_ITEM, (ff_id) => {
            let ff = this.folder_content.find(currFF => currFF.cp_id == ff_id)
            if (typeof ff != 'undefined' &&
                ff != null) {
                this.addMention(ff_id)
            }
        })

        if (document.getElementById("folder_iterate_list") != null) {
            document.getElementById("folder_iterate_list").addEventListener('scroll', this.HandleScroll)
        }

    },
    methods: {
        toByte(x) {
            Global.toByte(x)
        },
        NaveMention(mention_name, ff_id, type) {
            let span = document.createElement("span")
            span.classList = 'mention_slag'
            span.dataset.id = this.mention_id
            span.dataset.mention = ff_id
            span.dataset.type = type
            span.innerHTML = "$" + mention_name
            let mention_position = TextareaManager.getChildPositionByDataID(this.mention_id)

            // If the mention is clicked save the span to put the cursor in the right position
            this.spanMention = span;
            // important to detect first element even though the input area is empty
            if (mention_position == null ||
                (mention_position.row == 0 && mention_position.col == 0)) {
                if (span.dataset.id.length > 0) {
                    TextareaManager.AddToCursor(span)
                    Global.globalValue(VueSignals.REMOVE_TEXTAREA_PLACEHOLDER, true)
                }
            } else {
                let element = TextareaManager.getChildByDataID(this.mention_id)
                if (typeof element != 'undefined' && typeof element.textContent != 'undefined') {
                    element.innerHTML = "$" + mention_name
                    // Sometime an already created span won't change the data info that's why this
                    element.dataset.id = this.mention_id
                    element.dataset.mention = ff_id
                    element.dataset.type = type
                    if (element.classList.contains('mention_suggest')) {
                        element.classList.remove('mention_suggest')
                        element.classList.add('mention_slag')
                        TextareaManager.MoveCursorAfterAdd(element);
                    }
                }
            }

            // For mobile hovering is one tap so should be closed the mention list
            if (this.windowWidth <= 680){
                Global.globalValue(VueSignals.HIDE_KEYBOARD_FOLDER_LIST, true);
            }
            //DOMManager.RestartCursor()
        },
        addMention(mention_cpid, mention_name, type) {
            this.mention_filter_mode = false
            this.showAvailableContent = false
            Global.globalValue(VueSignals.HIDE_KEYBOARD_FOLDER_LIST, true)
        },
        // Back(){
        //     if(this.folder_tree.length !=1){
        //         this.folder_tree.splice(-1, 1)
        //     }
        //     this.ListContent(this.folder_tree[this.folder_tree.length-1])
        // },
        HandleScroll(event) {
            // @TODO move to global
            let container = event.target
            // if(container.scrollHeight  - container.clientHeight - container.scrollTop < 20 &&
            //     !this.generated_list_spinner && !this.endOfContent){
            //         this.ListContent(SessionManager.getActiveChannel().channel_id, this.skip )
            //         this.skip += 50
            // }
        },
        ListContent(id, skip) {
            this.generated_list_spinner = true
            FolderApi.listContent(id, skip).then(res => {
                if (typeof res.data != 'undefined' && typeof res.data.folder_content != 'undefined') {
                    this.node_error_message = false
                    if (!res.data.result) {
                        this.node_error_message = true
                    }
                    this.folder_name = res.data.folder_name
                    if (skip == 0) {
                        this.folder_content = res.data.folder_content
                        this.all_folders = res.data.folder_content
                    } else {
                        for (let i = 0; i < res.data.folder_content.length; i++) {
                            if (typeof res.data.folder_content[i].cp_id != 'undefined') {
                                this.folder_content.push(res.data.folder_content[i])
                            }
                        }
                    }

                    if (res.data.folder_content.length == 0) {
                        this.endOfContent = true
                    } else {
                        this.endOfContent = false
                    }
                }
                this.generated_list_spinner = false
                if (this.folder_content.length == 0) {
                    this.is_empty = true
                }
            })
        },
        getFileExtension(filename) {
            return Global.getFileIcon(filename)
        },
        clickHandler() {
            KeyboardManager.setListOpen(false)
            // Global.globalValue(VueSignals.TOOGLE_TEXT_CARET, true)

            // Put the cursor in the right position after clicking a mention
            TextareaManager.MoveCursorAfterAdd(this.spanMention);
            this.spanMention = null;
        },
        triggerMentionSearch(search) {
            if (search) {
                this.mention_match = search;
            }
            this.mention_match = this.mention_match.replace(/\$/g, '').toLowerCase().trim()
            let OriginalFF = this.all_folders;
            let FilterdFF = [];
            FilterdFF = OriginalFF.filter(currFF => currFF.name.toLowerCase().indexOf(this.mention_match.toLowerCase()) > -1)
            if (this.mention_match == '') {
                Global.globalValue(VueSignals.KEYBOARD_FILTERED_FF, OriginalFF)
            } else {
                if (FilterdFF.length > 0) {
                    Global.globalValue(VueSignals.KEYBOARD_FILTERED_FF, FilterdFF)
                }
            }
        }
    }
}
